// extracted by mini-css-extract-plugin
export default {"trailsText":"styles_trailsText__-p+MN","container":"styles_container__o-4fr","ticker":"styles_ticker__qmfDO"};